import { useCallback, useMemo, useRef, useState } from 'react';
import { getUnansweredFields, TOP_LEVEL_FIELDS } from './formValidation';

export function useUnansweredGate(
  fields: Record<string, unknown>,
  topLevelFields = TOP_LEVEL_FIELDS
) {
  const incompleteRef = useRef<HTMLDivElement>(null);
  const [submitAttempted, setSubmitAttempted] = useState<boolean>(false);

  const { unanswered } = useMemo(
    () => getUnansweredFields(fields, topLevelFields),
    [fields, topLevelFields]
  );
  const formIsComplete = unanswered.length === 0;

  // the box only appears after the first blocked submit, so nobody is nagged
  // while still filling the form in
  const showUnanswered = !formIsComplete && submitAttempted;

  const blockIfIncomplete = useCallback(
    (isFinalSubmit: boolean) => {
      if (!isFinalSubmit || formIsComplete) return false;

      setSubmitAttempted(true);
      // the box renders on the next commit, so the scroll has to wait for it
      setTimeout(() => {
        incompleteRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
        incompleteRef.current?.focus({ preventScroll: true });
      }, 0);
      return true;
    },
    [formIsComplete]
  );

  return { unanswered, showUnanswered, incompleteRef, blockIfIncomplete };
}
